import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { FoilPeelTestFormValues } from "../types/foilPeelTestTypes";

export function useFoilPeelTestForm() {
  const adhesionKeys = [
    "G01",
    "G02",
    "G03",
    "G04",
    "G05",
    "G06",
    "G07",
  ] as const;

  const adhesionEvaSchema = yup.object(
    adhesionKeys.reduce((acc, k) => {
      acc[k] = yup
        .number()
        .transform((v, ov) =>
          ov === "" || ov === null || typeof ov === "undefined" ? undefined : v
        )
        .typeError("Nur Zahlen erlaubt")
        .min(80, "Mindestens 80")
        .nullable()
        .notRequired();
      return acc;
    }, {} as Record<string, any>)
  );

  const adhesionBacksheetSchema = yup.object(
    adhesionKeys.reduce((acc, k) => {
      acc[k] = yup
        .number()
        .transform((v, ov) =>
          ov === "" || ov === null || typeof ov === "undefined" ? undefined : v
        )
        .typeError("Nur Zahlen erlaubt")
        .min(60, "Mindestens 60")
        .nullable()
        .notRequired();
      return acc;
    }, {} as Record<string, any>)
  );

  const schema = yup.object({
    adhesionEva: adhesionEvaSchema as any,
    adhesionBacksheet: adhesionBacksheetSchema as any,
  });

  return useForm<FoilPeelTestFormValues>({
    resolver: yupResolver(schema as any),
    defaultValues: {
      operator: "",
      testType: "",
      testForArticle: "",
      isGlassCleaned: false,

      laminatorRecipe: "",
      laminatorRecipeOther: "",

      laminatorPosition: undefined,

      frontGlassThickness: undefined,
      frontGlassThicknessOther: "",
      frontGlassBatchNumber: undefined,
      frontGlassManufacturingDate: "",

      evaFoilType: "",
      evaFoilTypeOther: "",
      evaFoilBatchNumber: undefined,
      evaFoilManufacturingDate: "",

      backsheetType: "",
      backsheetTypeOther: "",
      backsheetTypeBatchNumber: "",

      adhesionEva: {
        G01: undefined,
        G02: undefined,
        G03: undefined,
        G04: undefined,
        G05: undefined,
        G06: undefined,
        G07: undefined,
      },
      adhesionBacksheet: {
        G01: undefined,
        G02: undefined,
        G03: undefined,
        G04: undefined,
        G05: undefined,
        G06: undefined,
        G07: undefined,
      },
    },
  });
}
